import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

import { prepareWhoDidItListForView } from '../../EncounterDescNew/EditorAndDateSelect';

import './StudyManagerSelector.scss';

export default function StudyManagerSelector({ value, encounterStudyManagers, onChange }) {
  const items = value
    ? prepareWhoDidItListForView(encounterStudyManagers, value.uniqueIdentifier)
    : encounterStudyManagers.filter(({ deleteFlag }) => deleteFlag === 0);
  return (
    <Autocomplete
      value={value}
      onChange={function({ target }, studyManager) {
        onChange(studyManager);
      }}
      disableClearable
      fullWidth
      getOptionKey={option => option.uniqueIdentifier}
      getOptionLabel={option => option.name}
      disablePortal
      options={items}
      renderInput={params => (
        <TextField {...params} name="study_manager" label="Study Manager" variant="outlined" size="small" />
      )}
    />
  );
}
